export const uNaN = (value) => isNaN(value) ? undefined : value;